<template>
  <div class="animated fadeIn" id="dashboard">
    <b-row>
      <b-col sm="6" md="3" lg="3" v-if="canAccess(rules.ACCESS_ESPACE_BENEFICIAIRE)">
        <b-card
          title="Espace Bénéficiaire"
          :img-src="getSrc('EB')"
          img-alt="Espace Bénéficiaire"
          img-top
          class="landing-card landing-card-eb zoom"
        >
          <b-card-text>
            Accès à l'espace bénéficiaire
          </b-card-text>

          <a href="espace-beneficiaire/accueil" class="btn btn-primary stretched-link" @click="setSite(sites.EB)">Accéder<i
              class="fa fa-arrow-right ml-2"></i></a>
        </b-card>
        <!-- <b-jumbotron header="Espace Bénéficiaire" class="landing-card-eb zoom"
                     lead="Administration de l'espace bénéficiaire">
          <a href="espace-beneficiaire/accueil" class="btn btn-primary stretched-link" @click="setSite(sites.EB)">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-jumbotron> -->
      </b-col>
      <b-col sm="6" md="3" lg="3" v-if="canAccess(rules.ACCESS_ESPACE_GESTION)">
        <b-card
          title="Espace Gestion"
          :img-src="getSrc('EG')"
          img-alt="Espace Gestion"
          img-top
          class="landing-card landing-card-espace-gestion zoom"
        >
          <b-card-text>
            Accès à l'Espace Gestion
          </b-card-text>

          <a href="espace-gestion/accueil" class="btn btn-espace-gestion stretched-link" @click="setSite(sites.EG)">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-card>
        <!-- <b-jumbotron header="Espace Gestion" class="landing-card-espace-gestion zoom" lead="Accès à Espace Gestion">
          <a href="espace-gestion/accueil" class="btn btn-espace-gestion stretched-link" @click="setSite(sites.EG)">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-jumbotron> -->
      </b-col>
      <b-col sm="6" md="3" lg="3" v-if="canAccess(rules.ACCESS_ESPACE_QUALITE)">
        <b-card
          title="Espace Qualité"
          :img-src="getSrc('EQ')"
          img-alt="Espace Qualité"
          img-top
          class="landing-card landing-card-eq zoom"
        >
          <b-card-text>
            Accès à l'Espace Qualité
          </b-card-text>

          <a href="espace-qualite/campagnes/list" class="btn btn-success stretched-link" @click="setSite(sites.EC)">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-card>
        <!-- <b-jumbotron header="Espace Contrôle" class="landing-card-eb zoom" lead="Administration de l'espace contrôle">
          <a href="espace-qualite/accueil" class="btn btn-primary stretched-link" @click="setSite(sites.EC)">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-jumbotron> -->
      </b-col>
      <b-col sm="6" md="3" lg="3" v-if="canAccess(rules.ACCESS_ESPACE_RPA)">
        <b-card
          title="Suivi Cotisations"
          :img-src="getSrc('RPA')"
          img-alt="Suivi Cotisations"
          img-top
          class="landing-card landing-card-rpa zoom"
        >
          <b-card-text>
            Accès au Suivi des Cotisations
          </b-card-text>

          <a href="suivi-cotisations/accueil" style="cursor:default" class="btn btn-primary stretched-link">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-card>
        <!-- <b-jumbotron header="Espace Employeur" class="landing-card-eem disabled-content"
                     lead="Administration de l'espace employeur">
          <a href="admin/ee" class="btn btn-eem stretched-link" @click="setSite(sites.EEM)">Accéder<i class="fa fa-arrow-right ml-2"></i></a>
          <a href="#" style="cursor:default" class="btn btn-eem stretched-link">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-jumbotron> -->
      </b-col>
      <b-col sm="6" md="3" lg="3" v-if="canAccess(rules.ACCESS_ESPACE_EMPLOYEUR)">
        <b-card
          title="Espace Employeur"
          :img-src="getSrc('EEM')"
          img-alt="Espace employeur"
          img-top
          class="landing-card landing-card-eem zoom"
        >
          <b-card-text>
            Accès à l'espace employeur
          </b-card-text>

          <a href="espace-employeur/accueil" class="btn btn-eem stretched-link" @click="setSite(sites.EEM)">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-card>
        <!-- <b-jumbotron header="Espace Employeur" class="landing-card-eem disabled-content"
                     lead="Administration de l'espace employeur">
          <a href="admin/ee" class="btn btn-eem stretched-link" @click="setSite(sites.EEM)">Accéder<i class="fa fa-arrow-right ml-2"></i></a>
          <a href="#" style="cursor:default" class="btn btn-eem stretched-link">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-jumbotron> -->
      </b-col>
      <b-col sm="6" md="3" lg="3" v-if="canAccess(rules.ACCESS_ESPACE_RC)">
        <b-card
          title="Espace Relation Client"
          :img-src="getSrc('ERC')"
          img-alt="Espace Relation Client"
          img-top
          class="landing-card landing-card-erc zoom"
        >
          <b-card-text>
            Accès à l'espace relation client
          </b-card-text>

          <a href="espace-rc" class="btn btn-erc stretched-link" @click="setSite(sites.ERC)">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-card>
        <!-- <b-jumbotron header="Espace Salarié" class="landing-card-es disabled-content"
                     lead="Administration de l'espace salarié">
          <a href="admin/es" class="btn btn-success stretched-link" @click="setSite(sites.ESAL)">Accéder<i class="fa fa-arrow-right ml-2"></i></a>
          <a href="#" style="cursor:default" class="btn btn-success stretched-link">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-jumbotron> -->
      </b-col>
      <b-col sm="6" md="3" lg="3" v-if="canAccess(rules.CAN_ACCESS_ESPACE_BIBLIOTHEQUE)">
      <!-- <b-col sm="6" md="3" lg="3"> -->
        <b-card
          title="Espace Bibliothèque"
          :img-src="getSrc('BIBLIO')"
          img-alt="Espace Bibliothèque"
          img-top
          class="landing-card landing-card-ebiblio zoom"
        >
          <b-card-text>
            Accès à l'Espace Bibliothèque
          </b-card-text>

          <a href="espace-bibliotheque" class="btn btn-espace-bibliotheque stretched-link" @click="setSite(sites.BIBLIO)">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-card>
        <!-- <b-jumbotron header="Espace Contrôle" class="landing-card-eb zoom" lead="Administration de l'espace contrôle">
          <a href="espace-qualite/accueil" class="btn btn-primary stretched-link" @click="setSite(sites.EC)">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-jumbotron> -->
      </b-col>
    </b-row>
   <!--  <b-row>
      <b-col sm="6" md="3" lg="3" v-if="canAccess(rules.ACCESS_SALARIE)">
        <b-jumbotron header="Espace Salarié" class="landing-card-es disabled-content"
                     lead="Administration de l'espace salarié">
          <a href="admin/es" class="btn btn-success stretched-link" @click="setSite(sites.ESAL)">Accéder<i class="fa fa-arrow-right ml-2"></i></a>
          <a href="#" style="cursor:default" class="btn btn-success stretched-link">Accéder<i
            class="fa fa-arrow-right ml-2"></i></a>
        </b-jumbotron>
      </b-col>
    </b-row> -->
    <astuce-modal></astuce-modal>
  </div>
</template>

<script>
  import {
    isLoggedIn,
    handleLogin,
    handleLogout,
    getBaseUrl,
    getProvider,
    getIdToken,
    getAccessToken,
    getUser,
    setCurrentSite,
    clearSite
  } from "@/utils/auth";
  import {sites, rules, hasRule} from '@/utils/rulesHelper'
  import AstuceModal from "../components/AstuceModal";

  export default {
    name: "dashboard",
    components: {AstuceModal},
    data: function () {
      return {
        sites: sites,
        rules: rules
      };
    },
    created() {
      this.sendRequest();
    },
    methods: {
      setSite(site) {
        setCurrentSite(site)
      },
      canAccess(rule) {
        return hasRule(rule)
      },
      sendRequest() {
        let AUTH_TOKEN = getIdToken() + " " + getAccessToken();
        let self = this;

        this.$axios.defaults.baseURL = getBaseUrl();
        this.$axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
        this.$axios.defaults.headers.common["Accept"] = "application/json";
        this.$axios.defaults.headers.common["Provider"] = getProvider();

        this.$axios.get("/administration/accueil").then(response => {
        });
      },
      getSrc (card) {
        let images = require.context('@/assets/images/background/', false, /\.*$/)
        let image = ''

        if (card === 'EB') {
          image = 'montgolfiere.jpg'
        } else if (card === 'EG') {
          image = 'fondeg2.jpg'
        } else if (card === 'EQ') {
          image = 'espace-qualite.jpg'
        } else if (card === 'EEM') {
          image = 'espace-employeur.jpg'
        } else if (card === 'ERC') {
          image = 'bg_espace_rc_mini.jpg'
        } else if (card === 'RPA') {
          image = 'engrenages.png'
        } else if (card === 'BIBLIO') {
          image = 'bibliotheque.png'
        }

        return images('./' + image)
      },
    }
  };
</script>

<style>
  /* IE fix */
  #card-chart-01,
  #card-chart-02 {
    width: 100% !important;
  }

  .disabled-content {
    pointer-events: none;
    opacity: 0.4;
  }
  .landing-card .card-body {
    padding: .9rem .8rem;
  }
</style>
